module.exports = __webpack_public_path__ + "img/zqx.a285c935.png";